// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".agreeTxt[data-v-66866aaa]{overflow:hidden;font-size:14px;margin:30px}.agree h6[data-v-66866aaa]{font-size:16px;text-align:center}.agree[data-v-66866aaa]{overflow:hidden;width:1200px;padding:20px;margin:0 auto}.agree-con[data-v-66866aaa]{width:100%;background-color:#fff;padding:20px;margin:20px auto}.blick-tit[data-v-66866aaa]{font-size:16px;color:#333;cursor:pointer}.blick-tit[data-v-66866aaa]:hover{opacity:.7}", ""]);
// Exports
module.exports = exports;
